<template>
    <div class="standard-spec">
        <div class="preview-section">
            {{ specName }}<span class="el-form-item__description">（按公式填写后自动生成）</span>
            <mc-button
                :disabled="disabled"
                type="text"
                @click="onCustom"
            >
                {{ isCustom ? '取消自定义规格' : '自定义规格' }}
            </mc-button>
            <span class="ml20">
                C端展示预览：
            </span>
            {{ specNameToC }}<span class="el-form-item__description">（按公式填写后自动生成）</span>
        </div>
        <div
            class="handle-section"
        >
            <mc-form
                ref="form"
                :model="{standardSpecList, customSpec}"
                inline
                :disabled="disabled"
            >
                <div v-if="isCustom">
                    <mc-form-item
                        prop="customSpec"
                        :inline-message="true"
                        :rules="rules.customSpec"
                    >
                        <mc-input
                            v-model.trim="customSpec"
                            placeholder="请输入自定义规格"
                            style="width: 200px"
                        />
                    </mc-form-item>
                </div>
                <template v-else>
                    <div v-if="standardSpecList.length">
                        <add-container
                            :init-item="initItem"
                            :item-list="standardSpecList"
                            :max-size="3"
                            :show-delete-condition="showDeleteCondition"
                            :show-add-condition="showAddCondition"
                            :before-add="beforeAdd"
                            @change="onSpecChange"
                        >
                            <div
                                slot-scope="scope"
                                class="add-item"
                            >
                                <span>
                                    1{{ scope.item.baseUnitName }}=
                                </span>
                                <span>
                                    <mc-form-item
                                        :prop="`standardSpecList.${scope.$index}.relationCount`"
                                        :rules="rules.relationCount"
                                    >
                                        <mc-input
                                            v-model.trim="scope.item.relationCount"
                                            style="width: 180px"
                                            :disabled="scope.item.unitName === baseUnitName"
                                        />
                                    </mc-form-item>
                                </span>
                                <span>
                                    <mc-form-item
                                        :prop="`standardSpecList.${scope.$index}.unitName`"
                                        :rules="rules.unitId"
                                    >
                                        <mc-select
                                            class="spec-select"
                                            :value="scope.item.unitId"
                                            :source="originUnitList"
                                            labelKey="name"
                                            valueKey="id"
                                            filterable
                                            @change="(id) => { onSpecSelectChange(scope.item, id, scope.$index) }"
                                        />
                                    </mc-form-item>
                                </span>
                            </div>
                        </add-container>
                    </div>
                    <div v-else>
                        1{{ baseUnitName }}
                        <!-- 标品展示 -->
                        <mc-button
                            size="mini"
                            type="primary"
                            @click="addSpec"
                        >
                            新增
                        </mc-button>
                    </div>
                </template>
            </mc-form>
            <div
                v-if="specNameToC.length > 20"
                class="error-message text-danger"
            >
                规格总长度不超过20个字
            </div>
        </div>

        <div v-if="recommendSpecActual">
            <mc-tag
                theme="green"
                type="pure"
            >
                推荐
            </mc-tag>
            {{ recommendSpecActual }}
            <mc-button
                v-if="!disabled"
                type="text"
                size="small"
                @click="handleUseRecommendValue"
            >
                使用推荐
            </mc-button>
        </div>
    </div>
</template>

<script>
import Rules, { ValidateRule } from '@lsfe/rules';
import AddContainer from './AddContainer';

const getInitItem = (data = {}) => ({
    baseUnitId: data.baseUnitId || '', // 大规格单位id
    baseUnitName: data.baseUnitName || '',
    baseUnitType: data.baseUnitType || '', // 大规格单位类型 1标品单位（计件单位） 2散装单位（计量单位）
    unitId: data.unitId || '', // 小规格单位id
    unitName: data.unitName || '',
    unitType: data.unitType || '', // 小规格单位类型 1标品单位（计件单位） 2散装单位（计量单位）
    relationCount: data.relationCount || '', // 规格数量
});

export default {
    name: 'StandardSpec',
    components: {
        AddContainer,
    },
    props: {
        value: {
            type: Array,
            default: () => ([]),
        },
        baseUnitId: {
            type: [Number, String],
            default: 0,
        },
        // 基础单位
        baseUnitName: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        // 初始自定义规格
        initSpecActual: {
            type: String,
            default: '',
        },
        // 推荐的规格值
        recommendSpecActual: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            originUnitList: [],
            standardSpecList: this.value || [],
            initItem: getInitItem,
            isCustom: false,
            customSpec: this.initSpecActual || '',
            rules: {
                relationCount: [
                    Rules.isRequired('必填'),
                    new ValidateRule({
                        validator(rule, value, cb) {
                            const reg = /[^\u7ea6\-\d.]/;
                            const moreThreeDecimal = /\d*\.\d{4}/;
                            if (reg.test(value)) {
                                cb(new Error('字符不合法'));
                                return;
                            }
                            if (moreThreeDecimal.test(value)) {
                                cb(new Error('最多3位小数'));
                                return;
                            }
                            cb();
                        },
                    }),
                ],
                customSpec: [
                    Rules.isRequired('必填'),
                ],
                unitId: [
                    Rules.isRequired('必填'),
                ],
            },
        };
    },
    computed: {
        specName() {
            // 标品 自定义规格
            if (this.isCustom) return `${this.customSpec}/${this.baseUnitName}`;
            // todo 没有了
            if (!this.standardSpecList || !this.standardSpecList.length) return `1${this.baseUnitName}`;
            // 兼容：小规格单位=基础单位
            const lastUnitName = this.standardSpecList[0].unitName;
            if (lastUnitName === this.baseUnitName) return `1${this.baseUnitName}`;
            // 默认
            return `${this.specNameToC}/${this.baseUnitName}`;
        },
        specNameToC() {
            if (this.isCustom) return this.customSpec;
            if (!this.standardSpecList || !this.standardSpecList.length) return `1${this.baseUnitName}`;
            return this.standardSpecList.map((item) => `${item.relationCount}${item.unitName}`).reverse().join('*');
        },
        selectedSpecUnitIds() {
            return this.standardSpecList.map((item) => item.unitId);
        },
    },
    watch: {
        baseUnitName(name) {
            if (!name) return;
            this.resetStatus();
        },
        standardSpecList: {
            handler(val) {
                this.$emit('input', val);
            },
            deep: true,
        },
        specNameToC: {
            handler(val) {
                this.emitSpecActual(val);
            },
            immediate: true,
        },
    },
    created() {
        this.getAllUnit();
        if (this.initSpecActual && !this.value.length) {
            this.isCustom = true;
        }
        if (!this.isCustom && !this.value.length) {
            this.addSpec();
        }
    },
    methods: {
        async getAllUnit() {
            const { data } = await this.$service.listAllUnit({
                unitType: null,
            });
            if (!data) return;
            data.sort((m, n) => m.unitType - n.unitType).forEach((item) => { item.id = +item.id; });
            this.originUnitList = data;
        },
        onCustom() {
            this.isCustom = !this.isCustom;
            this.resetStatus();
        },
        // 使用推荐的规格值
        handleUseRecommendValue() {
            // 使用推荐时，切换到“自定义规格”
            this.isCustom = true;
            // 计算属性specNameToC变化，触发emit
            this.customSpec = this.recommendSpecActual;
        },
        addSpec(extraData) {
            const { baseUnitId, baseUnitName } = this;
            // 初始化时，补充大规格数据
            const initItem = getInitItem({
                baseUnitId,
                baseUnitName,
                baseUnitType: 1,
                ...extraData,
            });
            this.standardSpecList = [initItem];
        },
        // 每一层的大规格单位，第一层默认取基础单位，第二三层，取前一层的小规格单位名(unitName)
        getBaseUnitNameByLevel(level = 0) {
            if (level === 0) return this.baseUnitName;
            return this.standardSpecList[level - 1].unitName;
        },
        onSpecSelectChange(specItem, id, index) {
            if (id) {
                const node = this.originUnitList.find((item) => item.id === id);

                // 兼容：允许基础单位和规格单位相同，表示使用基础单位作为实际规格值。只能保留一条规格数据
                if (node.name === this.baseUnitName) {
                    this.addSpec({
                        relationCount: 1,
                        unitId: id,
                        unitName: node.name,
                        unitType: node.unitType,
                    });
                    return;
                }

                specItem.unitId = id;
                specItem.unitName = node.name;
                specItem.unitType = node.unitType;

                const nextSpec = this.standardSpecList[index + 1];
                if (nextSpec) {
                    // 兼容逻辑：本层选择散装单位，如果有下层数据，则清空
                    if (specItem.unitType === 2) {
                        this.standardSpecList.splice(index + 1);
                    }
                    // 如果有下一层，则更新下一层的大规格数据
                    nextSpec.baseUnitId = id;
                    nextSpec.baseUnitName = node.name;
                    nextSpec.baseUnitType = node.unitType;
                }
            } else {
                specItem.unitId = '';
                specItem.unitName = '';
                specItem.unitType = '';
            }
        },
        onSpecChange(changeType, data) {
            if (changeType === 'add') {
                const lastItem = data[data.length - 1]; // 最新一条
                const prevItem = data[data.length - 2]; // 上一条
                lastItem.baseUnitId = prevItem.unitId;
                lastItem.baseUnitName = prevItem.unitName;
                lastItem.baseUnitType = prevItem.unitType;
            }
        },
        emitSpecActual(val) {
            this.$emit('spec-actual-change', val);
        },
        showDeleteCondition(item, index, specList) {
            // 最后一条展示删除
            return index !== 0 && index === specList.length - 1;
        },
        showAddCondition(specList) {
            // 小于3层时，展示新增
            return specList.length < 3;
        },
        // 前校验是否可以新增
        beforeAdd(specList) {
            if (specList && specList.length) {
                const lastItem = specList[specList.length - 1];
                // 小规格和基础单位一致，不能新增
                if (lastItem.unitName === this.baseUnitName) return false;
                // 只有计件单位可以新增；
                if (lastItem.unitType === 1) return true;
                // 计量单位(散装单位)，无法进一步细化
                if (lastItem.unitType === 2) {
                    this.$message.warning(`当前单位${lastItem.unitName}无法进一步细化，只有单位为只、个等计件单位时，才能进一步细化`);
                    return false;
                }
            }
            return false;
        },
        resetStatus() {
            this.customSpec = '';
            if (this.isCustom) {
                this.standardSpecList = [];
            } else {
                this.addSpec();
            }
        },
        validate(callback) {
            if (this.specNameToC.length > 20) callback(false);
            if (this.$refs.form) {
                this.$refs.form.validate((valid) => {
                    if (!valid) callback(false);
                });
            }
            callback(true);
        },
    },
};
</script>

<style lang="scss" scoped>
.add-item {
    display: flex;
    justify-content: flex-start;
}
</style>
